import { connect } from 'react-redux';
import { fetchNoiseAlerts, setFilters, setDefFilters } from '../../actions/NoiseAlertsActions';
import { FILTERS_NOISE_ALERTS } from '../../constants/SettingsKeys';

import NoiseAlertsSettings from '../../components/AlertsSettings/NoiseAlertsSettings';
import { invalidateProject } from "../../actions/setters";

const DEFAULT_NOISE_PRIORITY_OPTIONS = [
  { value: 'A', label: 'A' },
  { value: 'B', label: 'B' },
  { value: 'C', label: 'C' },
  { value: 'D', label: 'D' },
];

const buildNoisePriorityOptions = (abcOptions = []) => {
  const mergedOptions = [...abcOptions];

  DEFAULT_NOISE_PRIORITY_OPTIONS.forEach((defaultOption) => {
    const hasMatch = mergedOptions.some(
      (option) =>
        String(option.label) === defaultOption.label ||
        String(option.DisplayName) === defaultOption.label
    );

    if (!hasMatch) {
      mergedOptions.push(defaultOption);
    }
  });

  return mergedOptions;
};

const mapAbcValuesToNoisePriorityLabels = (selectedValues, abcOptions = []) => {
  if (!Array.isArray(selectedValues)) {
    return selectedValues;
  }

  return selectedValues.map((selectedValue) => {
    const matchingOption = abcOptions.find(
      (option) => String(option.value) === String(selectedValue)
    );

    return matchingOption ? matchingOption.label : selectedValue;
  });
};

const mapStateToProps = (state, ownProps) => {
  const {
    selectedProject
  } = state.leaksList;
  const user = state.leaksList.user;
  const optionList = state.leaksList.optionList.options;
  const noisePriorityOptions = buildNoisePriorityOptions(optionList.ABC || []);
  return Object.assign({}, {
    user,
    selectedProject,
    initialValues: state.leaksList.filters.noiseAlerts.defFilters,
    optionList: {
      ...optionList,
      ABC: noisePriorityOptions,
    }
  }, ownProps);
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (values, dispatch, props) => {
    const {
      selectedProject,
      processFilters,
      optionList,
    } = props;

    var filters = processFilters(Object.assign({}, values));
    filters.filters = filters.filters.map((filter) =>
      filter.field === 'ABC'
        ? {
            ...filter,
            field: 'NoisePriority',
            value: mapAbcValuesToNoisePriorityLabels(
              filter.value,
              optionList.ABC
            ),
          }
        : filter
    );
    delete filters.defFilters.sortBy;
    delete filters.defFilters.sortByDir;
    dispatch(invalidateProject(selectedProject));
    dispatch(setDefFilters(filters.defFilters));
    dispatch(setFilters(filters.filters));
    dispatch(fetchNoiseAlerts(selectedProject));

    localStorage.setItem(FILTERS_NOISE_ALERTS, JSON.stringify(filters.defFilters));
  }
});

const CAlertsSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(NoiseAlertsSettings);

export default CAlertsSettings;
